// extracted by mini-css-extract-plugin
export default {"input":"input_input__974n6","main_login":"input_main_login__Uf4J2"};